import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { useCallback, useMemo } from 'sb-hooks'
import { ce2, constants, snowplow } from 'common/helpers'
import { intlMessageShape } from 'sb-react-intl'

import Button from 'components/_new/Button/Button'

import messages from './messages'


const SkipAMonthButton = (props) => {
  const { className, isVisible, onClick, fullWidth, snowplowMetadata } = props

  const handleClick = useCallback((event) => {
    if (typeof onClick === 'function') {
      onClick(event)
    }

    ce2.set(1, constants.analyticsEvents.skipMonthClick)
    snowplow.track(constants.snowplowEvents.skipMonthClick, snowplowMetadata)
    actions.models.modals.open(constants.modals.SkipAMonth)
  }, [ onClick, snowplowMetadata ])

  return (
    Boolean(isVisible) && (
      <Button
        className={className}
        fullWidth={fullWidth}
        title={messages.title}
        dataTestId={constants.testIds.profile.orderStatusButtons.skip}
        weight="normal"
        color="brand"
        size="md"
        uppercase
        onClick={handleClick}
      />
    )
  )
}

SkipAMonthButton.propTypes = {
  title: PropTypes.shape(intlMessageShape),
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  snowplowMetadata: PropTypes.shape({
    placement: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
}


export default connect({
  isVisible: 'models.subscription.isSkippable',
})(SkipAMonthButton)
